import { useState } from "react";
import { X } from "lucide-react";
import Input from "../../../../components/Input/Input";
import Button from "../../../../components/Button/Button";

/** Free-text tags with an Add button (Enter also adds). */
const TagInput = ({ id, name = "tag", label, tags, onChange, placeholder }) => {
  const [draft, setDraft] = useState("");

  const addTag = () => {
    const value = draft.trim();
    if (!value) return;
    const exists = tags.some((tag) => tag.toLowerCase() === value.toLowerCase());
    if (!exists) onChange([...tags, value]);
    setDraft("");
  };

  return (
    <div className="lp-tag-input">
      {label && (
        <label htmlFor={id} className="mb-1 mt-1 text-capitalize fw-semibold">
          {label}
        </label>
      )}
      <div className="lp-tag-input__row">
        <Input
          id={id}
          name={name}
          value={draft}
          placeholder={placeholder}
          onChangeHandler={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              addTag();
            }
          }}
        />
        <Button variant="outline-primary" onClick={addTag} disabled={!draft.trim()}>
          Add
        </Button>
      </div>
      {tags.length > 0 && (
        <div className="lp-tag-input__tags">
          {tags.map((tag) => (
            <span key={tag} className="lp-chip lp-tone-primary">
              {tag}
              <Button
                variant="plain"
                className="lp-btn-plain lp-chip__remove"
                icon={<X size={12} />}
                onClick={() => onChange(tags.filter((t) => t !== tag))}
                aria-label={`Remove ${tag}`}
              />
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TagInput;
